var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rankTop"},[_c('ul',_vm._l((_vm.pageList),function(item,index){return _c('li',{key:'rankTopItem' + index,class:{ selected: item.selected },on:{"click":function($event){return _vm.changeRankType(item, index)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }